// MT home dashboard (zone layout) strings: mtdOps. Keys use the "mtd-" prefix.
// Operations zone widgets (Forms in progress, My / All tickets) and the quick
// access rail (Calendar, Form favorites, Shortcuts, Shared links).
export default {
  en: {
    'mtd-my-equipment-tasks': 'My Equipment Tasks',
    'mtd-all-equipment-tasks': 'All Equipment Tasks',
    'mtd-forms-in-progress': 'Forms in progress',
    'mtd-nothing-in-progress': 'Nothing in progress',
    'mtd-start-from-favorites': 'Start a form from Form favorites.',
    'mtd-form-favorites': 'Form favorites',
    'mtd-all-forms': 'All forms ({n})',
    'mtd-my-tickets': 'My tickets',
    'mtd-all-tickets': 'All tickets',
    'mtd-open': 'Open',
    'mtd-open-tickets': 'Open tickets',
    'mtd-next-task-due': 'Next task due · {date}',
    'mtd-next-task-due-none': 'Next task due · none upcoming',
    'mtd-maintenance-scheduled': 'Maintenance · {n} scheduled',
    'mtd-open-resource-library': 'Open resource library',
    'mtd-added-lc': 'added {date}',
    'mtd-shared-links': 'Shared links',
    'mtd-manage-links': 'Manage links',
    'mtd-no-shared-links':
      'No shared links have been added for your organization.',
    'mtd-loading': 'Loading…',
  },
  es: {
    'mtd-my-equipment-tasks': 'Mis tareas de equipos',
    'mtd-all-equipment-tasks': 'Todas las tareas de equipos',
    'mtd-forms-in-progress': 'Formularios en curso',
    'mtd-nothing-in-progress': 'Nada en curso',
    'mtd-start-from-favorites':
      'Inicie un formulario desde Formularios favoritos.',
    'mtd-form-favorites': 'Formularios favoritos',
    'mtd-all-forms': 'Todos los formularios ({n})',
    'mtd-my-tickets': 'Mis tickets',
    'mtd-all-tickets': 'Todos los tickets',
    'mtd-open': 'Abiertos',
    'mtd-open-tickets': 'Abrir tickets',
    'mtd-next-task-due': 'Próxima tarea · {date}',
    'mtd-next-task-due-none': 'Próxima tarea · ninguna próxima',
    'mtd-maintenance-scheduled': 'Mantenimiento · {n} programadas',
    'mtd-open-resource-library': 'Abrir biblioteca de recursos',
    'mtd-added-lc': 'agregado {date}',
    'mtd-shared-links': 'Enlaces compartidos',
    'mtd-manage-links': 'Administrar enlaces',
    'mtd-no-shared-links':
      'No se han agregado enlaces compartidos para su organización.',
    'mtd-loading': 'Cargando…',
  },
  fr: {
    'mtd-my-equipment-tasks': 'Mes tâches d’équipement',
    'mtd-all-equipment-tasks': 'Toutes les tâches d’équipement',
    'mtd-forms-in-progress': 'Formulaires en cours',
    'mtd-nothing-in-progress': 'Rien en cours',
    'mtd-start-from-favorites':
      'Commencez un formulaire depuis Formulaires favoris.',
    'mtd-form-favorites': 'Formulaires favoris',
    'mtd-all-forms': 'Tous les formulaires ({n})',
    'mtd-my-tickets': 'Mes tickets',
    'mtd-all-tickets': 'Tous les tickets',
    'mtd-open': 'Ouverts',
    'mtd-open-tickets': 'Ouvrir les tickets',
    'mtd-next-task-due': 'Prochaine tâche · {date}',
    'mtd-next-task-due-none': 'Prochaine tâche · aucune à venir',
    'mtd-maintenance-scheduled': 'Maintenance · {n} planifiées',
    'mtd-open-resource-library': 'Ouvrir la bibliothèque de ressources',
    'mtd-added-lc': 'ajouté le {date}',
    'mtd-shared-links': 'Liens partagés',
    'mtd-manage-links': 'Gérer les liens',
    'mtd-no-shared-links':
      "Aucun lien partagé n'a été ajouté pour votre organisation.",
    'mtd-loading': 'Chargement…',
  },
  'fr-ca': {
    'mtd-my-equipment-tasks': 'Mes tâches d’équipement',
    'mtd-all-equipment-tasks': 'Toutes les tâches d’équipement',
    'mtd-forms-in-progress': 'Formulaires en cours',
    'mtd-nothing-in-progress': 'Rien en cours',
    'mtd-start-from-favorites':
      'Commencez un formulaire depuis Formulaires favoris.',
    'mtd-form-favorites': 'Formulaires favoris',
    'mtd-all-forms': 'Tous les formulaires ({n})',
    'mtd-my-tickets': 'Mes billets',
    'mtd-all-tickets': 'Tous les billets',
    'mtd-open': 'Ouverts',
    'mtd-open-tickets': 'Ouvrir les billets',
    'mtd-next-task-due': 'Prochaine tâche · {date}',
    'mtd-next-task-due-none': 'Prochaine tâche · aucune à venir',
    'mtd-maintenance-scheduled': 'Entretien · {n} planifiées',
    'mtd-open-resource-library': 'Ouvrir la bibliothèque de ressources',
    'mtd-added-lc': 'ajouté le {date}',
    'mtd-shared-links': 'Liens partagés',
    'mtd-manage-links': 'Gérer les liens',
    'mtd-no-shared-links':
      "Aucun lien partagé n'a été ajouté pour votre organisation.",
    'mtd-loading': 'Chargement…',
  },
};
